export default __webpack_public_path__ + "static/media/varunada_lazurite_sliver.a4ad03b0.png";